import posthog from 'posthog-js'
import { FeatureFlags } from './feature-flag.const'

// For detailed notes on how to use feature flags, please consult: https://www.notion.so/ecoplanet/Feature-flag-implementation-1d6182495b0980e0842cc1da36bc1e68#1ed182495b098066a7f8c27d2a3cae27
const isFeatureFlagEnabled = (flag: string): boolean => {
  return posthog.isFeatureEnabled(flag) ?? false
}

// To add a new feature flag, add it to the FeatureFlags const and export a method here
// const isHelloWorldEnabled = () => isFeatureFlagEnabled(FeatureFlags.HELLO_WORLD_FEATURE)

export const isAwarenessTabEnabled = () => isFeatureFlagEnabled(FeatureFlags.AWARENESS_TAB)
export const isCustomReferencePriceEnabled = () => isFeatureFlagEnabled(FeatureFlags.SAVINGS_CUSTOM_REFERENCE_PRICE)
export const isEasyOfferDashboardEnabled = () => isFeatureFlagEnabled(FeatureFlags.EASY_OFFER_DASHBOARD)

export const getFlagBootstrapValues = () => {
  return Object.values(FeatureFlags).reduce<Record<string, boolean>>((acc, flag) => {
    acc[flag] = false
    return acc
  }, {})
}
